import {
  FaFacebookF,
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  FaSnapchat,
  FaTiktok,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export const footer_social_links_icons = {
  social_whatsapp: (
    <FaWhatsapp className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_snapchat: (
    <FaSnapchat className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_tiktok: (
    <FaTiktok className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_facebook: (
    <FaFacebookF className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_twitter: (
    <FaXTwitter className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_instagram: (
    <FaInstagram className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_youtube: (
    <FaYoutube className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_linkedin: (
    <FaLinkedinIn className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
  social_github: (
    <FaGithub className="text-[15px] text-[#000]/30 dark:text-[#fff]/30" />
  ),
};

export const public_footer_social_links_icons = {
  social_whatsapp: <FaWhatsapp />,
  social_snapchat: <FaSnapchat />,
  social_tiktok: <FaTiktok />,
  social_facebook: <FaFacebookF />,
  social_twitter: <FaXTwitter />,
  social_instagram: <FaInstagram />,
  social_youtube: <FaYoutube />,
  social_linkedin: <FaLinkedinIn />,
  social_github: <FaGithub />,
};
